
import React, { FC, useState, useEffect } from 'react'
import { KTSVG } from '../../../../_metronic/helpers'
import * as a from '../'

type Props = {
}

export const THead: React.FC<Props> = ({ children }) => {

    return (
        <thead>
            {children}
        </thead>
    )
}